import { getCookie, setCookie } from './_Utils';

function errRate() {
    const starValue =
        document.getElementById('overallStarsStars').dataset.clickedon;
    const submitButton = document.querySelector('button[id="post-review"]');

    if (starValue > 0) {
        $('.fake-input').removeClass('error');
        $('.error-label').removeClass('show-error');
        submitButton.disabled = false; // Enable the submit button when the condition is met
    } else {
        $('.fake-input').addClass('error');
        $('.error-label').addClass('show-error');
        submitButton.disabled = true; // Disable the submit button when starValue is 0
    }

    document
        .getElementById('overallStarsStars')
        .addEventListener('change', () => {
            // When the overallStarsStars field changes, re-run the validation
            errRate();
        });
}

function reviews() {
    const reviewsEndpoint = 'https://reviews.clear.link';

    setTimeout(() => {
        $('input[name="custom_detected_brand"]').val(
            localStorage.getItem('MM_ISP')
        );
        $('input[name="custom_detected_zip"]').val(
            localStorage.getItem('MM_ZIP')
        );
    }, 2500);

    $('.review-form-small').validate({
        ignore: [],
        rules: {
            brand: {
                realBrand: true,
            },
        },
        messages: {
            brand: {
                realBrand: 'Please choose a valid provider',
            },
        },
    });
    $('.review-form-full').validate({
        ignore: [],
    });

    $('input[name="brand"]').blur((e) => {
        const brandInput = $(e.currentTarget);
        let brand = brandInput
            .parent('.awesomplete')
            .find('ul')
            .find('li[aria-selected="true"]');

        if (brand.length === 0) {
            brand = brandInput
                .parent('.awesomplete')
                .find('ul')
                .find('li')
                .first();
        }

        brandInput.val(brand.text());
    });

    $('.review-form input[name="zip"]').blur((e) => {
        const zip = $(e.currentTarget).val();
        $.ajax({
            method: 'POST',
            url: `/wp/wp-admin/admin-ajax.php?action=zipcheck&zip=${zip}`,
            success: (s) => {
                const res = JSON.parse(s);
                if (
                    res.data &&
                    res.data.validateZipCode &&
                    res.data.validateZipCode.cities
                ) {
                    const city = res.data.validateZipCode.cities[0];
                    $('.review-form input[name="city"][type="hidden"]').val(
                        city.city
                    );
                    $('.review-form input[name="state"][type="hidden"]').val(
                        city.state
                    );
                }
            },
        });
    });

    $('.review-form').submit((e) => {
        if ($(e.currentTarget).valid()) {
            e.preventDefault();
            const currentForm = $(e.currentTarget);

            const brandInput = $(currentForm).find('input[name="brand"]');
            let brand = brandInput
                .parent('.awesomplete')
                .find('ul')
                .find('li[aria-selected="true"]')
                .first();

            if (brand.length === 0) {
                brand = brandInput
                    .parent('.awesomplete')
                    .find('ul')
                    .find('li')
                    .first();
            }

            brandInput.val(brand.text());

            // generate tags
            const tagField = currentForm.find('input[name="tags"]');
            const tags = [];

            const brandName = $('input[name="brand"]').val();

            /* if (brandName === 'Xfinity') {
        brandName = 'Comcast';
        $('input[name="brand"]').val('Comcast');
      } */

            console.log(currentForm.find('input[name="city"]').val());

            tags.push(brandName);
            tags.push(currentForm.find('input[name="zip"]').val());
            tags.push(currentForm.find('input[name="city"]').val());
            tags.push(currentForm.find('input[name="state"]').val());
            tags.push(currentForm.find('select[name="custom_usertype"]').val());
            tags.push('highspeedinternet.com');

            if (currentForm.find('#review').length) {
                if (currentForm.find('#review').val().length) {
                    tags.push('has review');
                }
            }

            tagField.val(tags.toString());

            const btn = currentForm.find('button[type="submit"]');
            btn[0].classList.add('active');
            btn.attr('disabled', 'disabled');

            if (
                currentForm
                    .find('input[name="custom_street_address"]')
                    .val() === ''
            ) {
                currentForm
                    .find('input[name="custom_street_address"]')
                    .attr('disabled', 'disabled');
            }

            let dataFields = currentForm.serializeArray();
            // There are two city fields in the form. Need to use only one based on which field is filled.
            const firstNameFieldIndex = dataFields.findIndex(
                (field) => field.name === 'city'
            );
            if (!dataFields[firstNameFieldIndex].value) {
                // if city input is not filled by user, then remove it from payload
                dataFields = dataFields
                    .slice(0, firstNameFieldIndex)
                    .concat(dataFields.slice(firstNameFieldIndex + 1));
            } else {
                // if city input is filled by user, ignore auto-detected city
                dataFields = dataFields.filter(
                    (field, index) =>
                        field.name !== 'city' || index === firstNameFieldIndex
                );
            }

            // Same for states.
            const firstStateFieldIndex = dataFields.findIndex(
                (field) => field.name === 'state'
            );
            if (!dataFields[firstStateFieldIndex].value) {
                // if state is not filled by user, then remove it from payload
                dataFields = dataFields
                    .slice(0, firstStateFieldIndex)
                    .concat(dataFields.slice(firstStateFieldIndex + 1));
            } else {
                // if state input is filled by user, ignore auto-detected state
                dataFields = dataFields.filter(
                    (field, index) =>
                        field.name !== 'state' || index === firstStateFieldIndex
                );
            }

            // Generate query string from data fields array
            const datastring = dataFields
                .map(
                    (field) =>
                        `${field.name}=${encodeURIComponent(field.value)}`
                )
                .join('&');

            let spanish = false;
            if ($('html').attr('lang') === 'es') {
                spanish = true;
            }
            $.ajax({
                url: `${reviewsEndpoint}/add`,
                type: 'POST',
                data: datastring,
                success: (s) => {
                    if (s.message === 'Review created.') {
                        $('body, html').animate({
                            scrollTop: currentForm.offset().top - 50,
                        });
                        if (spanish === true) {
                            currentForm.html(
                                '<div class="margin-top text-center"><h3>Gracias</h3>' +
                                    '<p>Su propuesta ha sido recibida.</p></div>'
                            );
                        } else {
                            currentForm.html(
                                '<div class="margin-top text-center">' +
                                    '<h3>Thank You</h3><p>Your submission has been received.</p></div>'
                            );
                        }
                    } else {
                        currentForm
                            .find('.form-message')
                            .show()
                            .html(s.message);
                        btn[0].classList.remove('btn-active');
                        btn.attr('disabled', 'disabled');
                    }
                },
                error: () => {
                    console.log('error');
                    btn[0].classList.remove('btn-active');
                    btn.attr('disabled', 'disabled');
                },
            });
        }
        errRate();
    });

    function sortReviews(type) {
        const reviewContainer = $('.review-cards');
        const reviewCards = reviewContainer.find('.review-card');
        reviewCards.sort((a, b) => $(b).data('date') - $(a).data('date'));

        if (type === 'stars-low') {
            // type = 'stars';
            reviewCards.sort((a, b) => $(a).data('stars') - $(b).data('stars'));
        } else if (type === 'provider') {
            reviewCards.sort((a, b) =>
                $(a).data(type).localeCompare($(b).data(type))
            );
        } else {
            reviewCards.sort((a, b) => $(b).data(type) - $(a).data(type));
        }

        reviewContainer.html(reviewCards);
    }

    $(document).on('change', 'select[name="sortReviews"]', (e) => {
        // $('select[name="sortReviews"]').change(e => {
        sortReviews($(e.currentTarget).val());
    });

    $(document).on('click', '.reviews-more', (e) => {
        const toLoad = $(e.currentTarget).data('amount');

        if ($('.review-cards .review-card:hidden').length === 0) {
            let spanish = '';
            if ($('html').attr('lang') === 'es') {
                spanish = '&spanish=true';
            }

            const page = parseInt($('input[name="reviewsPage"]').val()) + 1;
            const query = `${$(
                'input[name="reviewsQuery"]'
            ).val()}&page=${page}${spanish}`;

            $('.reviews-more').addClass('active');

            $.ajax({
                url: `/wp/wp-admin/admin-ajax.php?action=load_reviews&${query}&loadmore=1`,
                // data: query,
                success: (s) => {
                    $('.reviews-more').removeClass('active');

                    if (s === 'empty') {
                        $('.reviews-more').fadeOut(100);
                        $('.review-cards').append('End of reviews.');
                    } else {
                        $('input[name="reviewsPage"]').val(page);
                        $('.review-cards').append(s);
                    }
                    $('.review-card').slideDown();
                },
            });
        } else {
            $(`.review-card:hidden:lt(${toLoad})`).slideDown();
            // if ($('.review-card:hidden').length === 0) {
            //   $('.reviews-more').fadeOut(100);
            // }
        }
    });

    if ($('.review-cards').data('display') > 0) {
        const display = $('.review-cards').data('display') - 1;
        $(`.review-cards .review-card:gt(${display})`).hide();
    }

    // Was this review helpful submission
    $(document).on('click', '.review-helpful', (e) => {
        const el = $(e.currentTarget);
        const uid = el.data('id'); // id of post
        const helpful = el.data('value'); // helpful or not_helpful
        const checkCookie = getCookie(uid);

        if (checkCookie !== '1') {
            $.ajax({
                url: `${reviewsEndpoint}/review/${uid}/${helpful}`,
                type: 'PUT',
                success: (s) => {
                    el.children('.helpful-val').html(s.helpful);
                    el.children('.not-helpful-val').html(s.not_helpful);
                    setCookie(uid, '1', 365);
                },
            });
        }
    });

    // review form stuff
    $('input[name="brand"]').blur((e) => {
        const brandInput = $(e.currentTarget);
        let brand = brandInput
            .parent('.awesomplete')
            .find('ul')
            .find('li[aria-selected="true"]');

        if (brand.length === 0) {
            brand = brandInput
                .parent('.awesomplete')
                .find('ul')
                .find('li')
                .first();
        }

        brandInput.val(brand.text());
    });

    function moveFieldTitle(e) {
        const el = e.currentTarget;
        if ($(el).val().length > 0) {
            $(el).addClass('filled');
            if ($(el).parents('.awesomplete').length) {
                $(el)
                    .parent('.awesomplete')
                    .next('.input-label')
                    .addClass('active');
            }
        } else {
            $(el).removeClass('filled');
        }
    }

    $('body').on(
        'keyup change',
        '.input-container input, .input-container textarea',
        (e) => {
            moveFieldTitle(e);
        }
    );

    function moveLabel(el) {
        if (!$(el).closest('div').hasClass('input-container')) {
            $(el).parent('div').next('.input-label').addClass('active');
        }
    }

    $('.input-container input, .input-container textarea')
        .focus((e) => {
            const el = e.currentTarget;
            moveLabel(el);
        })
        .blur((e) => {
            const el = e.currentTarget;
            if (
                $(el).val().length === 0 &&
                !$(el).closest('div').hasClass('input-container')
            ) {
                $(el).parent('div').next('.input-label').removeClass('active');
            }
        })
        .change((e) => {
            const el = e.currentTarget;
            moveLabel(el);
        });

    /* eslint-disable */
    $.validator.methods.email = function (value, element) {
        return (
            this.optional(element) ||
            /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(
                value
            )
        );
    };

    $.validator.addMethod(
        'realBrand',
        function (value, element) {
            const e = $(element).attr('id');
            let brandCount = $(`#${e}`)
                .parent('.awesomplete')
                .find('ul')
                .find('li[aria-selected="true"]');

            if (brandCount.length === 0) {
                brandCount = $(`#${e}`)
                    .parent('.awesomplete')
                    .find('ul')
                    .find('li')
                    .first();
            }

            if (
                brandCount.length === 1 &&
                brandCount.text().toLowerCase() == value.toLowerCase()
            ) {
                return true;
            } else {
                return false;
            }
        },
        'Please choose a valid provider'
    );
    /* eslint-enable */

    // Add click listeners to star labels and update the parent .star container with value
    $('.stars > label').each((i, v) => {
        const self = $(v);
        const stars = self.closest('.stars');

        self.on({
            click() {
                stars.attr(
                    'data-clickedOn',
                    parseFloat((20 - (self.index() - 1)) / 4).toFixed(1)
                );
            },
        });
    });
}

export { reviews };
